module.exports = __webpack_public_path__ + "img/tigongshangmenzhenzhi_image_zy.f1db212c.png";